import { SupportedCitySlugs } from "pages/partners/types";

export const MARRIOTT_CONFIG_COOKIE_NAME = "_sndr_partners_marriott_config";
export interface MarriottCookieConfig {
  shouldShowInterstitial: boolean;
}

export interface SubRegion {
  citySlug: SupportedCitySlugs;
  queryString: { geo_bounds?: string; geo_distance?: string; sort_by?: string };
}

export const MARRIOTT_PROFILE_URL =
  "https://www.marriott.com/loyalty/myAccount/profile.mi";

export const MARRIOTT_AVAILABILITY_URL =
  "https://www.marriott.com/reservation/availabilitySearch.mi?";

export const MARRIOTT_BASE_URL = "https://www.marriott.com";
